import { loadVGSCollect } from "@vgs/collect-js";
import { toRaw } from "vue";

const VGS_VAULT_ID = process.env.VUE_APP_VGS_VAULT_ID as string;
const VGS_ENVIRONMENT = process.env.VUE_APP_VGS_ENVIRONMENT as string;
const VGS_CNAME = process.env.VUE_APP_VGS_CNAME as string;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const collect: any = await loadVGSCollect({
  vaultId: VGS_VAULT_ID,
  environment: VGS_ENVIRONMENT,
  version: "2.18.0",
});

export default class VgsForm {
  private form;

  constructor() {
    this.form = VGS_CNAME ? collect.init().useCname(VGS_CNAME) : collect.init();
  }

  getForm() {
    return this.form;
  }

  toRaw() {
    return toRaw(this.form);
  }
}
